import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  removeChanges: () => void;
}

interface State {
}

export default class UnsavedDataModal extends React.PureComponent<Props, State> {
  render(): React.ReactNode {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={() => this.props.toggle()}
        centered={true}
        className="unsaved-modal"
      >
        <ModalBody>
          <h2>Unsaved data</h2>
          <span>You are not saved edited data.</span>
          <span>Are you sure want to continue?</span>
        </ModalBody>
        <ModalFooter>
          <Button
            color={'danger'}
            className='btn btn-text-danger'
            onClick={() => this.props.toggle()}
          >
            Cancel
          </Button>

          <Button
            color={'primary'}
            className='btn btn-primary'
            onClick={() => this.props.removeChanges()}
          >
            Continue
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
